import { apiWithAuth } from './api';
export const customerAPI = apiWithAuth.extend({
    prefixUrl: process.env.CUSTOMER_API_URL
});
